import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './predictedRemainingVolumeCapsulePreview.png';

export const predictedRemainingVolumeCapsuleDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Predicted Remaining Volume Capsule displays the % that my
                order leaves accounts for in the predicted market volume from
                now.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            src: chartPreview,
            altText: 'predicted-remaining-volume-capsule-chart-preview',
        },
    ],
};
